import { InputTextarea } from 'primereact/inputtextarea'
import { useState } from 'react'

import { FieldWrapper } from '../../../Components/Form'
import { FC } from '../../../Services'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { showToast } from '../../../utils/toast'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Contenuto del dialog per inviare una segnalazione operatore
 * @param {Object} props
 * @param {Function} props.onHide - Chiude il dialog
 */
export function ModalSegnalazione({ onHide }) {
  const [reportText, setReportText] = useState('')
  const [isSending, setIsSending] = useState(false)

  const sendReport = async () => {
    if (isSending) return
    setIsSending(true)
    try {
      const currentUrl = window.location.href
      await FC.service('info').create({
        action: 'sendReport',
        reportText,
        conversationUrl: currentUrl
      })
      showToast('success', t.gfSegnalazioneInviata, t.gfSegnalazioneInviataSuccesso)
    } catch (e) {
      showToast('error', t.errore, e?.message || t.gfErroreInvioSegnalazione)
    } finally {
      setIsSending(false)
      onHide()
    }
  }

  return (
    <>
      <div className="gf-dialog-modal__body">
        <FieldWrapper id="report-notes" label={t.gfNoteSegnalazione}>
          <InputTextarea
            id="report-notes"
            value={reportText}
            onChange={(e) => setReportText(e.target.value)}
            rows={5}
            autoResize
            disabled={isSending}
          />
        </FieldWrapper>
      </div>
      <div className="gf-dialog-modal__footer">
        <button type="button" className="gf-btn" onClick={onHide} disabled={isSending}>
          {t.annulla}
        </button>
        <button
          type="button"
          className="gf-btn gf-btn--primary"
          onClick={sendReport}
          disabled={isSending || !reportText.trim()}
        >
          {isSending ? <span className="gf-btn__spinner" aria-hidden="true" /> : null}
          {t.gfInvia}
        </button>
      </div>
    </>
  )
}
